var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b-btn',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Törlöm az aktualis sort'),expression:"'Törlöm az aktualis sort'"}],staticClass:"btn btn-sm  btn-danger btn-block btn-delete-row",on:{"click":function($event){_vm.deleteKetRow()}}},[_c('i',{staticClass:"fa fa-trash ",staticStyle:{"color":"white"}})])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f25a67f2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/DeleteKetRow.vue
// module id = Wvlj
// module chunks = 0